export default __webpack_public_path__ + "static/media/send2.c3c894e2.svg";